import React from "react";
import { Route, Redirect } from "react-router";
// import { useSelector } from "react-redux";
// import Login from "../../components/Registration/login";
import User from "../views/userRoute";

export function PrivateRoute({ children, ...rest }) {
  const isAuthenticated = localStorage.getItem("usertoken");

  return (
    <Route {...rest}>
      {isAuthenticated ? (
        children
      ) : (
        <>
          <User />
          <Redirect to="/"></Redirect>
        </>
      )}
    </Route>
  );
}
